/* tslint:disable */
/* eslint-disable */
import { exists } from '../runtime';

/**
 * Public projection of an approved review (GET /CourierReviews/public).
 * customerName is already abbreviated server-side ("Jane D."); no email/ids.
 */
export interface CourierReviewPublic {
    id: number;
    rating: number;
    title?: string;
    body: string;
    customerName: string;
    isFeatured?: boolean;
    createdAt?: Date;
}

export function CourierReviewPublicFromJSON(json: any): CourierReviewPublic {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'rating': json['rating'],
        'title': !exists(json, 'title') ? undefined : json['title'],
        'body': json['body'],
        'customerName': json['customerName'],
        'isFeatured': !exists(json, 'isFeatured') ? undefined : json['isFeatured'],
        'createdAt': !exists(json, 'createdAt') ? undefined : (json['createdAt'] === null ? undefined : new Date(json['createdAt'])),
    };
}
